
import { css } from 'lit';
export default css`
.location-list {
  display: flex;
}

  .location-list__filters {
  padding-right: 3rem;
}

  .location-list__card {
    --hf-location-card-margin-bottom: 1.375rem;
  }

  @media (min-width: 1024px) {

  .location-list__card-container {
    margin-top: 1rem;
  }
}

  .location-list__card-count {
  margin-bottom: 1.5rem;
}

  .location-list__card-count {
  display: flex;
}

  .location-list__card-count {
  justify-content: flex-end;
}

  .location-list__card-count {
  --tw-text-opacity: 1;
  color: rgba(67, 75, 90, var(--tw-text-opacity));
}
`;